import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Imported for its side effect: the beforeinstallprompt listener must be
// registered during bundle evaluation, before Chrome fires the event.
import './utils/pwaInstall';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import UpdatePrompt from './components/UpdatePrompt/UpdatePrompt';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// The update prompt renders into its own root rather than inside <App>. It has to
// survive whatever App is doing (including an error boundary tripping) and owns
// no app state, so keeping it out of the tree avoids threading a callback down
// through App just to display it.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const host = document.createElement('div');
    document.body.appendChild(host);

    const promptRoot = ReactDOM.createRoot(host);
    const close = () => {
      promptRoot.unmount();
      host.remove();
    };

    promptRoot.render(
      <UpdatePrompt registration={registration} onDismiss={close} />
    );
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
